import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { ArchivePoint } from '@src/types/Archivist';
import { useCallback, useMemo } from 'react';
import {
  useDataPointSearchActions,
  useDataPointSearchState,
} from '../context/DataPointSearchContext';

interface UseDataPointSelectionReturn {
  selectedCount: number;
  currentPageSelectionModel: string[];
  handleSelectionChange: (
    newSelectionModel: GridRowSelectionModel,
    currentPageRows: ArchivePoint[],
  ) => void;
  clearSelection: () => void;
}

export const useDataPointSelection = (
  currentPageRows: ArchivePoint[],
): UseDataPointSelectionReturn => {
  const state = useDataPointSearchState();
  const { syncPageSelection, clearSelection } = useDataPointSearchActions();

  const currentPageSelectionModel = useMemo(() => {
    if (!currentPageRows.length) {
      return [];
    }

    return currentPageRows.reduce<string[]>((acc, row) => {
      if (state.selection.has(row._id.$oid)) {
        acc.push(row._id.$oid);
      }
      return acc;
    }, []);
  }, [currentPageRows, state.selection]);

  const handleSelectionChange = useCallback(
    (newSelectionModel: GridRowSelectionModel, rows: ArchivePoint[]) => {
      const selectedIds = newSelectionModel.map((id) => id.toString());
      syncPageSelection(rows, selectedIds);
    },
    [syncPageSelection],
  );

  return {
    selectedCount: state.selection.size,
    currentPageSelectionModel,
    handleSelectionChange,
    clearSelection,
  };
};

export default useDataPointSelection;
